import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiStateNames } from '../shared/fi-state-proxy/fi-state-names';
import { FiTranslationNavigationTabsComponent } from './fi-translation-navigation-tabs.component';
import { FiTranslationListComponent } from '@fi-app/fi-translation/fi-translation-list/fi-translation-list.component';
import { FiTranslationService } from '@fi-app/fi-translation/fi-translation.service';
import { CommonService } from '@fi-app/components/common.service';

const TranslationState: Ng2StateDeclaration = {
    name: FiStateNames.Translation._name,
    url: '/Translation',
    abstract: true,
    component: FiTranslationNavigationTabsComponent,
};

const TranslationListState: Ng2StateDeclaration = {
    name: FiStateNames.Translation.List,
    url: '/?:languages&:searchMode&:searchText',
    component: FiTranslationListComponent,
    reloadOnSearch: false,
    resolve: {
        textLabels: [FiTranslationService, TranslationList_textLabels],
        globalDatabases: [CommonService, TranslationList_globalDatabases],
    },
};

export function TranslationList_textLabels(translationService: FiTranslationService) {
    return translationService.getTextLabels();
}

export function TranslationList_globalDatabases(commonService: CommonService) {
    return commonService.getGlobalDatabases();
}

export const TranslationStates: StatesModule = {
    states: [TranslationState, TranslationListState],
};
